export default __webpack_public_path__ + "static/22590-10543582a5cf124add657c7b633bdbf6.jpg";